import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface InstructionSection {
  title: string;
  steps: string[];
}

interface PracticalInstructionsProps {
  title: string;
  introduction: string;
  sections: InstructionSection[];
  safety?: string[];
}

const PracticalInstructions: React.FC<PracticalInstructionsProps> = ({ title, introduction, sections, safety = [] }) => (
  <Accordion defaultExpanded disableGutters sx={{ mb: 2, border: '1px solid rgba(25, 80, 70, 0.18)', borderRadius: '6px !important', '&:before': { display: 'none' } }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="practical-instructions-content" id="practical-instructions-header">
      <Box>
        <Typography variant="h6" fontWeight={800}>{title}</Typography>
        <Typography variant="body2" color="text.secondary">Step-by-step procedure and safety notes</Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0 }}>
      <Typography variant="body2" sx={{ mb: 1.5 }}>{introduction}</Typography>
      {sections.map((section) => (
        <Box key={section.title} sx={{ mb: 1.5 }}>
          <Typography variant="subtitle2" fontWeight={800}>{section.title}</Typography>
          <List component="ol" dense disablePadding sx={{ pl: 3, listStyleType: 'decimal', '& .MuiListItem-root': { display: 'list-item', py: 0.25 } }}>
            {section.steps.map((step, index) => (
              <ListItem component="li" key={`${section.title}-${index}`}>
                <ListItemText primary={step} primaryTypographyProps={{ variant: 'body2' }} />
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
      {safety.length > 0 && <Box sx={{ mt: 1.5, p: 1.25, borderLeft: '4px solid #c97822', backgroundColor: 'rgba(201, 120, 34, 0.08)' }}>
        <Typography variant="subtitle2" fontWeight={800}>Safety and good practice</Typography>
        <List dense disablePadding sx={{ pl: 2.25, listStyleType: 'disc', '& .MuiListItem-root': { display: 'list-item', py: 0.2 } }}>
          {safety.map((item) => <ListItem component="li" key={item}><ListItemText primary={item} primaryTypographyProps={{ variant: 'body2' }} /></ListItem>)}
        </List>
      </Box>}
    </AccordionDetails>
  </Accordion>
);

export default PracticalInstructions;
